import React, { useMemo, useState } from "react";
import clsx from "clsx";

type Props = {
  src: string;
  alt: string;
  className?: string; // cho container
  fallbackSrc?: string;
  squareThreshold?: number; // ví dụ 0.9~1.1 coi là "gần vuông"
};

export function ClinicImage({
  src,
  alt,
  className,
  fallbackSrc,
  squareThreshold = 0.1, // |w/h - 1| <= 0.1 => gần vuông
}: Props) {
  const [shape, setShape] = useState<
    "unknown" | "landscape" | "portrait" | "square"
  >("unknown");
  const [resolvedSrc, setResolvedSrc] = useState(src);

  const isSquareish = shape === "square" || shape === "portrait";

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      loading="lazy"
      className={clsx(
        "transition-transform duration-300 group-hover:scale-105",
        isSquareish
          ? "relative z-10 h-[100%] max-w-full object-contain"
          : "w-full h-full object-cover"
      )}
      onLoad={(e) => {
        const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
        if (!w || !h) return;

        const r = w / h;
        const nearSquare = Math.abs(r - 1) <= squareThreshold;

        if (nearSquare) setShape("square");
        else if (r > 1) setShape("landscape");
        else setShape("portrait");
      }}
      onError={() => {
        if (fallbackSrc) setResolvedSrc(fallbackSrc);
      }}
    />
  );
}
